import React from 'react';
import {
	Button,
	Dropdown,
	Grid,
	GridColumn,
	Header,
	Label,
	Modal,
	Pagination,
	Segment,
	Table
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import styles from './styles';
import { observable, toJS } from 'mobx';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';
import SortByField from 'components/SortByField';
import UiShared from 'stores/UiShared';
import Auth from 'stores/Auth';
import Reminder from 'stores/Reminder';
import RemindersScreen from 'stores/ui/manager/Reminders';
import Practice from 'stores/Practice';
import { isAfter, isBefore, areEqual, isSameDay } from 'date-fns';
const PRACTICES_EMPTY = [{ key: 0, value: 0, text: 'All Practices' }];

@withRouter
@inject(rootStore => ({
	remindersScreen: rootStore.ui.manager.reminders,
	uiShared: rootStore.uiShared,
	auth: rootStore.auth
}))
@observer
export default class ReminderList extends React.Component {
	props: {
		remindersScreen: RemindersScreen,
		uiShared: UiShared,
		auth?: Auth
	};

	@observable pageSize: number = 100;
	@observable showConfirmDlg: boolean;
	@observable itemToDisplayId: number = null;
	@observable practices: Array<object> = PRACTICES_EMPTY;

	msgStore: MsgStore = new MsgStore();

	async componentDidMount() {
		const { remindersScreen } = this.props;
		try {
			remindersScreen.loadItems();
			await this.loadPractices();
		} catch (err) {
			this.msgStore.setError(err);
		}
	}

	loadPractices = async () => {
		const practices = await Practice.loadPracticeDDLByUser(this.props.auth?.user?.id);
		this.practices = PRACTICES_EMPTY.concat(practices);
	};

	render() {
		const remindersScreen: RemindersScreen = this.props.remindersScreen;
		const { items } = remindersScreen;
		const { practices } = this;
		return (
			<Segment loading={remindersScreen.isLoading}>
				<Header as="h1">Reminders</Header>
				<MessageBox msgStore={this.msgStore} />
				<div className={styles.viewSelectorRow}>
					<div>
						<Label size="large" basic className={styles.viewLbl}>
							Practice:
						</Label>
						<Dropdown
							style={{ width: '370px' }}
							options={practices}
							value={remindersScreen.practiceID}
							onChange={(e, data) => {
								remindersScreen.setPracticeID(data.value);
							}}
							selection
						/>
					</div>
					<div>
						<Label size="large" basic className={styles.viewLbl}>
							Records per page:
						</Label>
						<Dropdown
							selection
							placeholder="Records per page"
							value={this.pageSize}
							onChange={(e, data) => {
								this.pageSize = data.value;
								remindersScreen.setPageSize(data.value);
							}}
							compact
							options={[
								{ text: '10', value: 10 },
								{ text: '20', value: 20 },
								{ text: '50', value: 50 },
								{ text: '100', value: 100 }
							]}
						/>
					</div>
				</div>

				<Grid>
					<GridColumn>
						<Table celled>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>
										<SortByField
											label="Practice"
											field="searchPracticeName"
											filterType="like"
											store={remindersScreen}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Prescriber"
											field="searchPrescriberName"
											filterType="like"
											store={remindersScreen}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Patient Name"
											field="searchPatientName"
											filterType="like"
											store={remindersScreen}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Product"
											field="searchProductName"
											filterType="like"
											store={remindersScreen}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>Last Approval</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Next Due"
											label2="Date"
											field="due"
											store={remindersScreen}
											enableFiltering
											filterType="date"
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>Actions</Table.HeaderCell>
								</Table.Row>
							</Table.Header>

							<Table.Body>
								{items.map((el: Reminder, idx) => (
									<Table.Row key={idx}>
										<Table.Cell>{el.searchPracticeName}</Table.Cell>
										<Table.Cell>{el.searchPrescriberName}</Table.Cell>
										<Table.Cell>{el.searchPatientName}</Table.Cell>
										<Table.Cell>{el.searchProductName}</Table.Cell>
										<Table.Cell>{el.Rx.finalisationDate?.toDate().format('DD/MM/YY')}</Table.Cell>
										<Table.Cell style={this.formatStatus(el)}>
											{el.due?.toDate().format('DD/MM/YY')}
										</Table.Cell>
										<Table.Cell>
											<Button
												icon="edit"
												size="small"
												label="Action"
												primary
												onClick={() => {
													this.itemToDisplayId = el.id;
													this.showConfirmDlg = true;
												}}
											/>
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>

							<Table.Footer>
								<Table.Row>
									<Table.HeaderCell colSpan="8" textAlign="right">
										{remindersScreen.numberOfPages > 0 && (
											<Pagination
												activePage={remindersScreen.pageIndex + 1}
												totalPages={remindersScreen.numberOfPages}
												onPageChange={(e, { activePage }) =>
													remindersScreen.setPageIndex(activePage - 1)
												}
											/>
										)}
									</Table.HeaderCell>
								</Table.Row>
							</Table.Footer>
						</Table>
					</GridColumn>
				</Grid>
				<Modal
					size="mini"
					open={this.showConfirmDlg}
					onClose={() => (this.showConfirmDlg = false)}
					className={styles.modalConfirmation}
					closeIcon={true}
					dimmer={'blurring'}
				>
					<Modal.Content>
						<p>Do you wish to remove the reminder?</p>
					</Modal.Content>
					<Modal.Actions>
						<Button
							negative
							onClick={() => {
								this.showConfirmDlg = false;
								this.itemToDisplayId = null;
							}}
						>
							Cancel
						</Button>
						<Button
							positive
							icon="checkmark"
							labelPosition="right"
							content="OK"
							onClick={async () => {
								try {
									remindersScreen.loadingCounter++;
									this.showConfirmDlg = false;
									const item = await Reminder.loadById(this.itemToDisplayId);
									await item.setAttributes({ actioned: true });
									this.itemToDisplayId = null;
									remindersScreen.loadingCounter--;
									remindersScreen.reload();
								} catch (e) {
									this.itemToDisplayId = null;
									this.showConfirmDlg = false;
									throw e;
								}
							}}
						/>
					</Modal.Actions>
				</Modal>
			</Segment>
		);
	}
	formatStatus(el) {
		const now = new Date();
		const flag = isSameDay(new Date(el.due), now) || isBefore(new Date(el.due), now);
		return {
			color: flag ? 'red' : 'black',
			fontWeight: flag ? 'bold' : 'normal'
		};
	}
}



// WEBPACK FOOTER //
// ./src/routes/Manager/Reminders/index.js